<div class="o-grid o-grid--wrap">
	<ng-container *ngFor="let serviceName of vm.serviceNames ; let $index=index">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-33@lg-and-up u-osb-md" 
	       *ngIf="vm.services[serviceName].enabled && (!vm.lowerAuthSupportRequired || vm.services[serviceName].lowerAuthenticationSupported)">
			<card-service-instant [service]="vm.services[serviceName]" [isNarrow]="true"></card-service-instant>
		</div>
	</ng-container>
</div>
